import React from 'react';
import { Countdown } from './ui/Countdown';
export function UrgencyBar() {
  return <section className="py-12 bg-[#000000]" data-id="element-286">
      <div className="container mx-auto px-4" data-id="element-287">
        <div className="max-w-3xl mx-auto" data-id="element-288">
          <div className="bg-black rounded-3xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-289">
            <div className="absolute top-0 left-0 w-40 h-40 bg-red-500/15 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-290"></div>
            <div className="absolute bottom-0 right-0 w-40 h-40 bg-red-500/15 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-291"></div>

            <div className="relative z-10" data-id="element-292">
              <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-xs font-black uppercase tracking-wider mb-5" data-id="element-293">
                🔥 Oferta por tiempo limitado 🔥
              </div>

              <h2 className="text-lg md:text-xl font-black text-white uppercase tracking-tight mb-6" data-id="element-294">
                El precio de lanzamiento cierra en:
              </h2>

              <div className="rounded-2xl p-5 mb-6 inline-block border border-red-400/30" style={{
              background: 'linear-gradient(135deg, #7f1d1d 0%, #dc2626 50%, #991b1b 100%)'
            }} data-id="element-295">
                <Countdown data-id="element-296" />
              </div>

              <p className="text-red-400 font-black text-sm uppercase tracking-wide" data-id="element-297">
                ⚠️ Después sube a $49.990 ARS — No vuelve
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}